/** Skeleton — soft pulsing placeholder, NVL-tuned. */
import { cn } from "../../lib/cn";

export function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn("bg-surface-2 rounded-[10px] animate-pulse", className)}
      style={{ animationDuration: "1.6s" }}
      aria-busy="true"
      aria-live="polite"
      {...props}
    />
  );
}

export function CardSkeleton({ className }) {
  return (
    <div className={cn("rounded-[22px] border border-line overflow-hidden bg-surface", className)}>
      <Skeleton className="aspect-[16/10] rounded-none" />
      <div className="p-6 space-y-3">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-5 w-3/4" />
        <Skeleton className="h-3 w-full" />
        <Skeleton className="h-3 w-5/6" />
        <div className="flex items-center justify-between pt-4 mt-2 border-t border-line">
          <Skeleton className="h-5 w-16" />
          <Skeleton className="h-8 w-8 rounded-full" />
        </div>
      </div>
    </div>
  );
}
